"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum;
(function (TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum) {
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["RegistrationFailed"] = "REGISTRATION_FAILED";
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["RegistrationCompleted"] = "REGISTRATION_COMPLETED";
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["CreationInProgress"] = "CREATION_IN_PROGRESS";
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["RefreshInProgress"] = "REFRESH_IN_PROGRESS";
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["Completed"] = "COMPLETED";
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["Failed"] = "FAILED";
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["Canceled"] = "CANCELED";
    TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum["Queued"] = "QUEUED";
})(TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum = exports.TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum || (exports.TableauExtractserviceV1GetCurrentExtractCommandStatusResponseStatusEnum = {}));
function TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSON(json) {
    return TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSONTyped(json, false);
}
exports.TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSON = TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSON;
function TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'numberOfReadPages': !runtime_1.exists(json, 'number_of_read_pages') ? undefined : json['number_of_read_pages'],
        'numberOfConvertedRecords': !runtime_1.exists(json, 'number_of_converted_records') ? undefined : json['number_of_converted_records'],
        'numberOfWroteRecords': !runtime_1.exists(json, 'number_of_wrote_records') ? undefined : json['number_of_wrote_records'],
        'runTime': !runtime_1.exists(json, 'run_time') ? undefined : json['run_time'],
    };
}
exports.TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSONTyped = TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSONTyped;
function TableauExtractserviceV1GetCurrentExtractCommandStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'number_of_read_pages': value.numberOfReadPages,
        'number_of_converted_records': value.numberOfConvertedRecords,
        'number_of_wrote_records': value.numberOfWroteRecords,
        'run_time': value.runTime,
    };
}
exports.TableauExtractserviceV1GetCurrentExtractCommandStatusResponseToJSON = TableauExtractserviceV1GetCurrentExtractCommandStatusResponseToJSON;
